export default __webpack_public_path__ + "static/Inter-Bold-203405b2a2d613cb775e151ce4dbe75a.woff2";